export function formatMessageTimestamp(value: string | Date): string {
  if (!value) {
    return '';
  }

  const date = typeof value === 'string' ? new Date(value) : value;
  if (Number.isNaN(date.getTime())) {
    return '';
  }

  return new Intl.DateTimeFormat(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  }).format(date);
}

export function formatMessageDuration(durationMs?: number): string {
  if (typeof durationMs !== 'number' || Number.isNaN(durationMs)) {
    return '';
  }

  const safeDuration = Math.max(0, durationMs);

  if (safeDuration < 1000) {
    return `${safeDuration} ms`;
  }

  const totalSeconds = safeDuration / 1000;
  if (totalSeconds < 60) {
    const precision = totalSeconds < 10 ? 2 : 1;
    return `${totalSeconds.toFixed(precision)} s`;
  }

  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.round(totalSeconds % 60);
  const minutesLabel = minutes > 0 ? `${minutes}m` : '';
  const secondsLabel = `${seconds}s`;

  return `${minutesLabel} ${secondsLabel}`.trim();
}

